(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/core-js/get-iterator', 'babel-runtime/core-js/object/keys', 'babel-runtime/helpers/slicedToArray', 'babel-runtime/helpers/toArray', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/toConsumableArray', './consts', './utils', '../util/lang', './toPath'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/get-iterator'), require('babel-runtime/core-js/object/keys'), require('babel-runtime/helpers/slicedToArray'), require('babel-runtime/helpers/toArray'), require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/toConsumableArray'), require('./consts'), require('./utils'), require('../util/lang'), require('./toPath'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.getIterator, global.keys, global.slicedToArray, global.toArray, global._extends, global.toConsumableArray, global.consts, global.utils, global.lang, global.toPath);
    global.apply = mod.exports;
  }
})(this, function (exports, _getIterator2, _keys, _slicedToArray2, _toArray2, _extends2, _toConsumableArray2, _consts, _utils, _lang, _toPath) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.apply = undefined;

  var _getIterator3 = _interopRequireDefault(_getIterator2);

  var _keys2 = _interopRequireDefault(_keys);

  var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

  var _toArray3 = _interopRequireDefault(_toArray2);

  var _extends3 = _interopRequireDefault(_extends2);

  var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * Makes a copy of value.
   * @function
   * @param {*} value The value to make a copy of
   * @param {boolean} asArray The value should be copied as an array
   * @returns {Object|Array} A copy of value
   * @memberof path
   * @private
   * @since 1.0.0
   */


  var copy = function copy(value, asArray) {
    if ((0, _lang.isNil)(value)) {
      if (asArray) return [];
      return {};
    }

    if (Array.isArray(value)) return [].concat((0, _toConsumableArray3.default)(value));
    return (0, _extends3.default)({}, value);
  };
  /**
   * Makes a copy of <code>value</code> if necessary.
   * @function
   * @param {*} value The value to make a copy of
   * @param {string} propType The type of the accessed property in <code>value</code>
   * @param {boolean} doCopy Whether to make a copy or not
   * @returns {Object|Array} A copy of value, or not ;)
   * @private
   * @since 1.0.0
   */


  var copyIfNecessary = function copyIfNecessary(value, propType, doCopy) {
    if (!doCopy) return value;
    return copy(value, propType === _consts.index);
  };
  /**
   * Operation to apply on a nested property of an object, to be called by {@link core.apply|apply}.
   * @memberof path
   * @callback operation
   * @param {*} obj The last nested object
   * @param {string|number} prop The prop of the last nested object
   * @param {*} value The value of the prop
   * @param {...*} args The remaining args (passed to the {@link core.appliedOperation|appliedOperation})
   * @private
   * @since 1.0.0
   */

  /**
   * A function able to apply an {@link core.operation|operation} on a nested property of an object, returned by {@link core.apply|apply}.
   * @memberof path
   * @callback appliedOperation
   * @param {*} obj The last nested object
   * @param {string} path The prop of the last nested object
   * @param {...*} args The remaining args (to be passed to the {@link core.operation|operation})
   * @returns {*} Result of the operation
   * @private
   * @since 1.0.0
   */

  /**
   * Creates a function able to apply <code>operation</code> on a nested property.
   * @memberof path
   * @function
   * @param {core.operation} operation The operation to apply
   * @returns {core.appliedOperation} A function able to apply <code>operation</code>
   * @private
   * @since 1.0.0
   */


  var apply = function apply(operation) {
    var curried = function curried(pPath) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var path = (0, _toPath.toPath)(pPath);
      if (path.length === 0) throw new TypeError('path should not be empty');

      var applier = function applier(obj, appliedPaths) {
        var walkPath = function walkPath(curObj, curPath, remPath) {
          var isCopy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

          var _remPath = (0, _toArray3.default)(remPath),
              curProp = _remPath[0],
              pathRest = _remPath.slice(1);

          var _curProp = (0, _slicedToArray3.default)(curProp, 2),
              propType = _curProp[0],
              propValue = _curProp[1];

          if (propType === _consts.slice) {
            var _getSliceBounds = (0, _utils.getSliceBounds)(propValue, (0, _lang.length)(curObj)),
                _getSliceBounds2 = (0, _slicedToArray3.default)(_getSliceBounds, 2),
                start = _getSliceBounds2[0],
                end = _getSliceBounds2[1];

            var newArr = copy(curObj, true);
            var _noop = true;

            for (var i = start; i < end; i++) {
              var _walkPath = walkPath(newArr, curPath, [[_consts.index, i]].concat((0, _toConsumableArray3.default)(pathRest)), true),
                  _walkPath2 = (0, _slicedToArray3.default)(_walkPath, 1),
                  iNoop = _walkPath2[0];

              _noop = _noop && iNoop;
            }

            if (_noop) return [true, curObj];
            return [false, newArr];
          }

          if (propType === _consts.list || propType === _consts.allProps) {
            var _newObj = copy(curObj, false);

            var _noop2 = true;
            var listProps = propType === _consts.allProps ? (0, _keys2.default)(_newObj) : propValue;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = (0, _getIterator3.default)(listProps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var listProp = _step.value;

                var _walkPath3 = walkPath(_newObj, curPath, [[_consts.prop, listProp]].concat((0, _toConsumableArray3.default)(pathRest)), true),
                    _walkPath4 = (0, _slicedToArray3.default)(_walkPath3, 1),
                    _iNoop = _walkPath4[0];

                _noop2 = _noop2 && _iNoop;
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            if (_noop2) return [true, curObj];
            return [false, _newObj];
          }

          var value = (0, _lang.isNil)(curObj) ? undefined : curObj[propValue];
          var doCopy = !isCopy && !(0, _utils.pathAlreadyApplied)(curPath, appliedPaths);

          if (remPath.length === 1) {
            var _newObj2 = copyIfNecessary(curObj, propType, doCopy);

            operation.apply(undefined, [_newObj2, propValue, value].concat(args));
            return [false, _newObj2];
          }

          var _walkPath5 = walkPath(value, [].concat((0, _toConsumableArray3.default)(curPath), [curProp]), pathRest),
              _walkPath6 = (0, _slicedToArray3.default)(_walkPath5, 2),
              noop = _walkPath6[0],
              newValue = _walkPath6[1];

          if (noop) return [true, curObj];
          var newObj = copyIfNecessary(curObj, propType, doCopy);
          newObj[propValue] = newValue;
          return [false, newObj];
        };

        var _walkPath7 = walkPath(obj, [], path),
            _walkPath8 = (0, _slicedToArray3.default)(_walkPath7, 2),
            result = _walkPath8[1];

        return result;
      };

      applier.path = path;

      var unaryApplier = function unaryApplier(arg) {
        return applier(arg);
      };

      unaryApplier.applier = applier;
      return unaryApplier;
    };

    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var firstArg = args[0],
          argsRest = args.slice(1);
      if ((0, _lang.isString)(firstArg)) return curried.apply(undefined, args);
      return curried.apply(undefined, (0, _toConsumableArray3.default)(argsRest))(firstArg);
    };
  };

  exports.apply = apply;
});